import { Button } from "@/shared/ui/button.tsx";
import { NavLink, useNavigate } from "react-router-dom";
import logo from '@assets/sialogo.png'
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@/shared/ui/sheet.tsx"
import { AlignJustify } from "lucide-react";


const Header = () => {
  const navigate = useNavigate()
  return (
    <header className="w-full h-[7vh] px-10 bg-white/40 backdrop-blur-xl border-b border-purple-200/50 flex items-center justify-between relative z-10">
      <div className="flex items-center">
        <img src={logo} className="w-16 cursor-pointer" onClick={() => navigate('/')} />
      </div>
      <Sheet>
        <SheetTrigger>
          <Button size="icon" variant="outline" className="flex md:hidden"><AlignJustify /></Button>
        </SheetTrigger>
        <SheetContent className="flex flex-col gap-7 h-full justify-center">
          <NavLink to='/inside' className="text-sm font-poppins tracking-wide">Inside siAi</NavLink>
          {/*
            <NavLink to='/explore' className="text-sm font-poppins tracking-wide">Explore</NavLink>
          */}
          <NavLink to='/investors' className="text-sm font-poppins tracking-wide">For Investors</NavLink>
          <NavLink to='/team' className="text-sm font-poppins tracking-wide">Our Team</NavLink>
          <Button className="bg-gradient-to-b from-[#320177] to-[#5D02DD] font-poppins" onClick={() => navigate('/contact')}>Join the waitlist</Button>
        </SheetContent>
      </Sheet>
      <div className="md:flex items-center gap-5 hidden">
        <NavLink to='/inside' className="text-sm font-poppins tracking-wide">Inside siAi</NavLink>
        {/*
          <NavLink to='/explore' className="text-sm font-poppins tracking-wide">Explore</NavLink>
        */}
        <NavLink to='/investors' className="text-sm font-poppins tracking-wide">For Investors</NavLink>
        <NavLink to='/team' className="text-sm font-poppins tracking-wide">Our Team</NavLink>
        <Button className="bg-gradient-to-b from-[#320177] to-[#5D02DD] rounded-full text-sm px-4 font-poppins" onClick={() => navigate('/contact')}>Join the waitlist</Button>
      </div>

    </header>
  )
}

export default Header;

